import React from "react";
import PhonesInput from "react-phone-number-input/input";
import styles from "./phoneInput.module.css";
import TextComponent from "../textComponent/TextComponent";
const PhoneInput = (props) => {
  const onChangeText = (e) => {
    setTimeout(() => {
      props?.onChange(e);
    }, 10);
  };
  return (
    <div
      className={`${styles.phoneLabel} ${props?.className}`}
      style={props?.style}
    >
      {props?.label ? (
        <TextComponent
          className={`${styles.label} ${props?.labelClass}`}
          color={props?.LabelColor ? props?.LabelColor : "var(--black-color)"}
          fontFamily={
            props?.LabelFontFamily ? props?.LabelFontFamily : "Poppins-Medium"
          }
          padding={"0px"}
        >
          {props?.label}
        </TextComponent>
      ) : null}

      <div className={`${styles.phoneInput}  ${props?.InputclassName} `}>
        <PhonesInput
          style={{
            outline: "none",
            border: 0,
            width: "100%",
          }}
          placeholder={props?.placeholder}
          className={`${styles.PhoneNumber} ${props?.InnerInputclassName} `}
          defaultCountry="US"
          value={props?.value}
          maxLength={14}
          onChange={(e) => onChangeText(e)}
          disabled={props?.disabled}
        />
      </div>
    </div>
  );
};

export default PhoneInput;
